import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "../components/ui/dialog";
import {
  Calendar,
  Clock,
  User,
  ArrowRight,
  MessageCircle,
} from "lucide-react";
import { CONTACT } from "./constants";

export default function BlogDialog({ post, open, onOpenChange }) {
  if (!post) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="blog-dialog"
        className="!max-w-3xl !w-[95vw] !p-0 !gap-0 !rounded-3xl overflow-hidden max-h-[92vh] flex flex-col border-slate-200 bg-white"
      >
        <DialogTitle className="sr-only">{post.title}</DialogTitle>
        <div className="relative shrink-0">
          <div className="aspect-[21/9] overflow-hidden bg-slate-100">
            <img
              src={post.img}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-white">
            <span className="inline-flex items-center gap-1.5 bg-[var(--ab-blue)] text-white px-3 py-1 rounded-full text-[0.65rem] font-bold uppercase tracking-widest">
              {post.category}
            </span>
            <h2 className="font-display mt-3 text-2xl sm:text-4xl font-extrabold leading-tight">
              {post.title}
            </h2>
            <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-blue-100">
              <span className="flex items-center gap-1.5">
                <User className="h-3.5 w-3.5" />
                {post.author}
              </span>
              <span className="flex items-center gap-1.5">
                <Calendar className="h-3.5 w-3.5" />
                {post.date}
              </span>
              <span className="flex items-center gap-1.5">
                <Clock className="h-3.5 w-3.5" />
                {post.readTime}
              </span>
            </div>
          </div>
        </div>

        <div
          className="overflow-y-auto px-6 sm:px-10 py-8 space-y-4"
          data-testid="blog-dialog-body"
        >
          <p className="text-lg text-slate-700 leading-relaxed font-medium">
            {post.excerpt}
          </p>
          <div className="ab-divider my-3" />
          {post.content.map((block, i) =>
            block.type === "h" ? (
              <h3
                key={i}
                className="font-display text-xl sm:text-2xl font-bold text-[var(--ab-navy)] mt-6"
              >
                {block.text}
              </h3>
            ) : (
              <p
                key={i}
                className="text-slate-600 leading-relaxed text-[0.98rem]"
              >
                {block.text}
              </p>
            )
          )}

          <div className="mt-8 p-6 rounded-2xl bg-[var(--ab-bg-soft)] border border-slate-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <div className="font-display font-bold text-[var(--ab-navy)]">
                Bu konuyu sizin için uygulayalım mı?
              </div>
              <div className="text-sm text-slate-600 mt-1">
                30 dakikalık ücretsiz danışmanlık için bize ulaşın.
              </div>
            </div>
            <a
              href={CONTACT.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="blog-dialog-cta"
              className="ab-btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold shrink-0"
            >
              <MessageCircle className="h-4 w-4" />
              WhatsApp&apos;tan Yaz
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
